import { Report61Container } from "../../../containers/SupportSystem/Reports/Report61Container";
export function Report61Page() {
    return (
        <Report61Container />
    );

}